import { GetCodiceAtecoQuery } from '../../_graphql/generated';

export type CodiceAtecoState = {
  loading: boolean;
  lista: GetCodiceAtecoQuery['anagrafica_codice_ateco'];
  failure: any;
};

export const initialCodiceAtecoState: CodiceAtecoState = {
  loading: false,
  lista: [],
  failure: '',
};
